import { ButtonVariant } from '../../../@packages/ui/components/buttons/types';
import { DYHeroBannerWithCTAButtonsTemplateVariables } from './DYHeroBannerWithCTAButtons';
import { HeroBannerWithCTAButtonsProps } from './HeroBannerWithCTAButtons';
import { transformCustomizableText } from '../utils';

export function transformDYTemplateVariables(
  dyTemplateVariables: DYHeroBannerWithCTAButtonsTemplateVariables['data'],
): Omit<HeroBannerWithCTAButtonsProps, 'onClick'> {
  const title = dyTemplateVariables.title?.text ? transformCustomizableText(dyTemplateVariables.title) : undefined;
  const subtitle = dyTemplateVariables.subtitle?.text
    ? transformCustomizableText(dyTemplateVariables.subtitle)
    : undefined;
  const ctaType = dyTemplateVariables.ctaType as ButtonVariant;
  return {
    title,
    subtitle,
    ctas: dyTemplateVariables.ctas,
    ctaType,
    images: dyTemplateVariables.images,
  };
}
